<template>
  <VuePerfectScrollbar
    id="user-signature-page"
    class="user-signature-page h-full"
    :class="{ 'my-account-scroll-area-mobile': !isDesktop }"
  >

    <!-- pop-up to update phone -->
      <vs-popup id="phone-popup" :title="$t('SIGAWEB_DEMO').Update_Phone_Title" :active.sync="popupPhone">
        <p>{{ $t("SIGAWEB_DEMO").Update_Phone_Text }}</p>
        <br>
        <vs-input
          :name="$t('HELP_ATTENDANCE').Phone"
          icon-no-border
          icon="icon icon-phone"
          icon-pack="feather"
          :label="$t('REGISTER').Field_Phone"
          :placeholder="$t('REGISTER').Field_Phone"
          v-model="form.phone"
          class="w-full"
          v-mask="'## #####-####'"
        />
        <br>
        <vs-button
          class="w-full mt-5"
          @click="updatePhone"
          >{{ $t("SIGAWEB_DEMO").Update }}
        </vs-button>
      </vs-popup>

    <!-- :settings="settings" -->
    <swiper :options="swiperOption" :key="$vs.rtl" v-if="!isDesktop">
      <swiper-slide v-if="isProfileFree">
        <vx-card
          class="mb-5 pb-4 signature-user"
        >
          <!-- :title="$t('SIGAWEB_DEMO').Plan_Free_Title" -->
          <div class="pt-4 signature-text">
            {{ $t("SIGAWEB_DEMO").Free_Text_First }}
          </div>
          <p class="mt-5 signature-text">
            {{ $t("SIGAWEB_DEMO").Free_Text_Second }}
          </p>
          <p class="mt-5 signature-text" v-html="$t('SIGAWEB_DEMO').Free_Text_Third"></p>
          <!-- {{ $t("SIGAWEB_DEMO").Free_Text_Third }} <a href="mailto:prevendas@cma.com.br"> {{ $t("SIGAWEB_DEMO").Free_Text_Email }}</a> -->

            <!-- <a class="cursor-pointer" @click.stop="openAttendance">{{
              $t("SIGAWEB_DEMO").Free_Text_Click_Here
            }}</a> -->

          <!-- <div class="text-primary-g carousel-header w-full h-full" v-if="sentDemoRequest">Vimos que já fez um pedido de demonstração ou já expirou. </div>
          <div class="text-primary-g carousel-header w-full h-full" v-if="sentDemoRequest"><small>Caso fez o pedido de demonstração, aguarde que receberá um email quando for aprovado.</small></div>
          <div class="mt-5 text-primary-g carousel-header w-full h-full" v-if="sentDemoRequest">Conheça nossos planos de assinatura <a class="cursor-pointer" @click.stop="$emit('open-packages')">clicando aqui</a></div>
          <div class="text-primary-g carousel-header w-full h-full" v-if="!sentDemoRequest">Conheça nossos planos de assinatura. Peça uma demonstração de um de nossos planos.</div>
          <div class="mt-10 text-primary-g carousel-header w-full h-full" v-if="sentDemoRequest">Caso estiver com dúvidas sobre assinaturas e demonstração, entre em contato <a class="cursor-pointer" @click.stop="openAttendance">clicando aqui</a></div> -->
          <vs-button
            class="w-full mt-5"
            @click="requestDemo"
            :disabled="requestingDemo"
            >{{ $t("SIGAWEB_DEMO").Request_Demo }}
          </vs-button>
        </vx-card>

      </swiper-slide>
      <swiper-slide v-if="isProfileDemo || isProfileSubscribe">
        <vx-card
          :title="getFieldName('name', currentSignature)"
          class="mb-5 pb-4 signature-user"

        >
          <div class="pt-4">
           {{ getFieldName("desc", currentSignature) }}
          </div>
          <div class="mt-5" v-if="isProfileDemo">
            <span class="">
              {{ $t("SIGAWEB_DEMO").Signature_Valid_Until }}
              {{ currentSignature.validate | moment("from") }}</span
            >
            <vs-chip
              class="status-badge"
              color="primary"
              v-if="signatureActive"
            ></vs-chip>
            <vs-chip
              class="status-badge"
              color="warning"
              v-if="signatureAlmostExpiring"
            ></vs-chip>
          </div>
          <div class="mt-5" v-if="isProfileSubscribe">
            <span class="">{{ $t("SIGAWEB_DEMO").Signature_Active }}</span>
            <vs-chip
              class="status-badge"
              color="primary"
            ></vs-chip>
          </div>

          <!-- <vs-chip class="status-badge" color="danger" v-if=""></vs-chip> -->
        </vx-card>
        <!-- <div
          v-for="(content, indexx) in getFieldName('content', currentSignature)"
          :key="indexx + 11"
          class="text-primary-g w-full h-full ml-3"
        >
          > {{ content }}
        </div> -->
      </swiper-slide>
    </swiper>

    <div class="" v-if="isDesktop">
      <div class="flex items-center" v-if="isProfileFree">
        <vx-card class="mb-5 pb-4 signature-user">
            <h4>{{ $t("SIGAWEB_DEMO").Plan_Free_Title }}</h4>
            <div class="signature-text">
              {{ $t("SIGAWEB_DEMO").Free_Text_First }}
            </div>
            <div class="signature-text">
              {{ $t("SIGAWEB_DEMO").Free_Text_Second }}
            </div>
            <div class="signature-text">
              <div v-html="$t('SIGAWEB_DEMO').Free_Text_Third"></div>
              <!-- {{ $t("SIGAWEB_DEMO").Free_Text_Third }}  -->
              <!-- <a href="mailto:prevendas@cma.com.br"> {{ $t("SIGAWEB_DEMO").Free_Text_Email }}</a> -->
            </div>
            <div class="signature-text">
              {{ $t("SIGAWEB_DEMO").Free_Text_Doubts }} <a @click="openAttendance()">{{ $t("SIGAWEB_DEMO").Click_Here }}</a>
            </div>
            <vs-button
              class="mt-5"
              @click="requestDemo"
              :disabled="requestingDemo"
              >{{ $t("SIGAWEB_DEMO").Free_Text_Click_Here }}</vs-button
            >
        </vx-card>

      </div>

        <!-- :title="
          isProfileDemo
            ? $t('SIGAWEB_DEMO').Plan_Demo_Title
            : $t('SIGAWEB_DEMO').Plan_Subscribe_Title
        " -->

        <vx-card
          v-if="isProfileDemo || isProfileSubscribe"
          :title="getFieldName('name', currentSignature)"
        >
          <div class="signature-text" v-if="isProfileDemo">
            <span>
              {{ $t("SIGAWEB_DEMO").Signature_Valid_Until }}
              {{ currentSignature.validate | moment("from") }}</span
            >
            <vs-chip
              class="status-badge"
              color="primary"
              v-if="signatureActive"
            ></vs-chip>
            <vs-chip
              class="status-badge"
              color="warning"
              v-if="signatureAlmostExpiring"
            ></vs-chip>
          </div>
          <div class="signature-text" v-if="isProfileSubscribe">
            <span>{{ $t("SIGAWEB_DEMO").Signature_Active }}</span>
            <vs-chip
              class="status-badge"
              color="primary"
            ></vs-chip>
          </div>
        </vx-card>
        <!-- <div
          v-for="(content, indexx) in getFieldName('content', currentSignature)"
          :key="indexx + 11"
          class=""
        >
          > {{ content }}
        </div> -->

    </div>
    <div v-if="!isDesktop" class="v-nav-menu-swipe-area" v-hammer:swipe.right="onClose"></div>
  </VuePerfectScrollbar>
</template>

<script>
import AppConstants from "../../appConstants";
import messagesNotifyHelper from "../../helpers/messages-notify-helper";
import userService from "../../providers/userService";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";
import { ENUM_LOCALE, getLocaleCode } from "@/helpers/locale-helper";
import Flags from "../../components/translate/Flags";
import { EventBus } from "../../event-bus";
import ClientSignatures from "../../plugins/ClientSignatures";
import translateFieldHelper from "../../helpers/translate-field-helper";
import convertDatetimeHelper from "../../helpers/convert-datetime-helper";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import messageDialogHelper from "../../helpers/message-dialog-helper";
import { getCodeLang } from "../../helpers/locale-helper";
import localStorageHelper from "../../helpers/local-storage-helper";
import checkDeviceTypeHelper from '../../helpers/check-device-type-helper';
import { SYSTEM_SERVER_ERROR_CODE } from "../../enums/enum-system-server-error-code";




export default {
  components: {
    VuePerfectScrollbar,
    vSelect,
    Flags,
    swiper,
    swiperSlide
  },
  created() {
    EventBus.$emit(
      AppConstants.BUS_EVENT_HEADER_MOBILE_TITLE,
      this.$t("MY_ACCOUNT").Title
    );
    this.loadData();
    // console.log('[duration]',this.$moment().duration(2,'days'))
  },
  data() {
    return {
      form: {
        phone: ""
      },
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
        swipeEasing: true
      },
      currentSignature: {},
      signatures: [],
      sentDemoRequest: false,
      swiperOption: {
        // pagination: {
        //   el: '.swiper-pagination'
        // }
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // }
      },
      requestingDemo: false,
      popupPhone: false
    };
  },
  computed: {
    signatureActive() {
      if (!this.currentSignature.validate) {
        return false;
      }
      const days = this.$moment(this.currentSignature.validate).diff(
        this.$moment(),
        "days"
      );
      return days > 30;
    },
    signatureAlmostExpiring() {
      if (!this.currentSignature.validate) {
        return false;
      }
      const days = this.$moment(this.currentSignature.validate).diff(
        this.$moment(),
        "days"
      );
      return days <= 30;
    },
    isProfileFree() {
      return this.currentSignature.profile == AppConstants.USER_PROFILE.FREE;
    },
    isProfileDemo() {
      return this.currentSignature.profile == AppConstants.USER_PROFILE.DEMO;
    },
    isProfileSubscribe() {
      return (
        this.currentSignature.profile == AppConstants.USER_PROFILE.SUBSCRIBER
      );
    },
    isDesktop() {
      return this.$store.state.isDesktop;
    },
    getTitle() {
      return this.isDesktop ? "" : this.$t("USER_SIGNATURE").Title;
    },
    safrasSite() {
      return this.$t('GENERAL').Safras_Url_Request;
    },
    // safrasSiteEs() {
    //   return this.$t('GENERAL').Safras_Url_Request;
    // },
    // safrasSiteAr() {
    //   return this.$t('GENERAL').Safras_Url_Request;
    // },
    isDesktop() {
        return this.$store.state.isDesktop;
      },
  },
  watch: {
    "$i18n.locale"(locale) {
      // userService.updateUser(new URLSearchParams(), {language: getLocaleCode(locale)});
      // multi language - when change value request new data from server
      // this.form.language = getLocaleCode(locale);
      // this.loadData(false);
      this.loadData();
    }
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    openAttendance() {
      EventBus.$emit(
        AppConstants.BUS_EVENT_OPENA_ATTENDANCE,
        this.$t("SIGAWEB_DEMO").Attendance_Message
      );
    },
    checkSendDemoRequest() {
      userService
        .checkRequestDemo(new URLSearchParams())
        .then(resp => {
          this.sentDemoRequest = resp;
        })
        .catch(err => console.log(err));
    },
    requestDemo() {
      if (this.currentLocale() == 'PtBr') {
        this.requestingDemo = true;
        this.$vs.loading({
          container: "#user-signature-page",
          scale: 0.6
        });
        userService
          .requestDemo(new URLSearchParams())
          .then(() => {
            this.$vs.loading.close("#user-signature-page > .con-vs-loading");
            messageDialogHelper.displayDialogAccept(
              this.$t("SIGAWEB_DEMO").Dialog_Title,
              this.$t("SIGAWEB_DEMO").SentRequest,
              () => {
                this.sentDemoRequest = true;
                this.requestingDemo = false;
              }
            );
            // messagesNotifyHelper.successNotify('Demonstração', 'Pedido enviado com sucesso.');
          })
          .catch(error => {
            if (error.code == SYSTEM_SERVER_ERROR_CODE.USER_PHONE_NOT_FOUND.code ) {
              this.$vs.loading.close("#user-signature-page > .con-vs-loading");
              this.popupPhone = true;
            }
            console.log(error);
            // let message = '';
            // switch (error.codigo) {
            //   case 4001:
            //       message = `${error.entidade} ${this.$t('SIGAWEB_DEMO').Field_Empty}`;
            //       break;
            //   case 4002:
            //       message = `${error.entidade} ${this.$t('SIGAWEB_DEMO').Field_Invalid_Format}`;
            //       break;
            //   case 4003:
            //       message = `${this.$t('SIGAWEB_DEMO').User_Exist}`;
            //       break;
            //   case 4004:
            //       message = `${this.$t('SIGAWEB_DEMO').User_Demo_Exist}`;
            //       break;
            //     default:
            //       message = error.descricao;
            // }
            // message += `${this.$t('SIGAWEB_DEMO').Contact}`;

            // this.$vs.loading.close("#user-signature-page > .con-vs-loading");
            // messageDialogHelper.displayDialogAcceptCancel(this.$t('SIGAWEB_DEMO').Dialog_Title, message, (val) => {
            //   this.requestingDemo = false;
            //   if (val == 'cancel') {
            //     this.openAttendance();
            //   }
            // });
          });
      } else if (checkDeviceTypeHelper.isNativeApp()) {
        if (checkDeviceTypeHelper.isReactApp()) {
          biometryHelper.openExternalUrl(this.safrasSite);
        } else {
          cordova.InAppBrowser.open(this.safrasSite, '_system');
        }
      } else {
        window.open(this.safrasSite, '_blank');
      };
    },
    updatePhone() {
      userService
        .updatePhone(new URLSearchParams(), this.form)
        .then(() => {
          this.requestDemo();
          this.popupPhone = false
        });
    },
    formatDate(val, obj) {
      return convertDatetimeHelper.formatDate(val, obj);
    },
    getFieldName(field, data) {
      return translateFieldHelper.getTranslateField(field, data);
    },
    loadData() {
      Promise.all([
        userService.getCurrentSignature(new URLSearchParams()),
        userService.getUserSignatures(new URLSearchParams()),
        userService.checkRequestDemo(new URLSearchParams())
      ])
        .then(res => {
          this.currentSignature = res[0];
          this.signatures = res[1];
          this.sentDemoRequest = res[2].data;
          // console.log("[this.sentDemoRequest]", res[2]);
          // console.log("[signature validate]", this.currentSignature.validate);
          // console.log('[signature validate moment]', this.$moment(this.currentSignature.validate));
          // console.log('[date]',this.$moment(this.currentSignature.validate).days())
          // console.log(
          //   "[date]",
          //   this.$moment(this.currentSignature.validate).diff(
          //     this.$moment(),
          //     "days"
          //   )
          // );
          // console.log('[date]',this.$moment().add(5, 'days').diff(this.$moment(), 'days'))
          // moment(@Deadline).diff(moment(),'days');
        })
        .catch(err => console.log(err));
    },
    onBack() {
      EventBus.$emit(AppConstants.BUS_EVENT_OPEN_USER_MENU_MOBILE);
      this.$router.back();
    },
    currentLocale() {
      const localeCode = getCodeLang(localStorageHelper.getLocale());
      return localeCode
    },
  },
  mounted() {
    EventBus.$on(AppConstants.BUS_EVENT_HEADER_MOBILE_BACK, () => {
      this.onBack();
    });
  },
  beforeDestroy() {
    EventBus.$off(AppConstants.BUS_EVENT_HEADER_MOBILE_BACK);
  }
};
</script>

<style lang="scss">
#user-email-config {
  h5 {
    margin-bottom: 10px;
  }
  .vs-col {
    margin-top: 6px;
  }
  .input-switch {
    align-self: center;
  }
}

.row-btn {
  margin: 10px 0px;
}
.custom-scroll-content-my-account {
  height: calc(100% - 100px);
}
.my-account-help-language {
  margin-left: 10px;
}
.required-field {
  margin-left: 2px;
  color: red;
}

.theme-dark {
  .vs__clear {
    background-color: #363c42 !important;
  }
  .vs__open-indicator {
    background-color: #363c42 !important;
  }
}
#my-account-scroll {
  #flags {
    float: left;
  }
}

.mobile #user-signature-page {
  .vx-card {
    width: auto;
    padding: 0px;
    margin: 10px !important;
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, -0.91) !important;
  }
}

.user-signature-page {
  .vx-card {
    margin: 10px;
    width: auto;
    padding-bottom: 5px;
  }
}

</style>
